import PropTypes from 'prop-types';
import qualifications from 'utils/qualifications';
import { DB_PREFIX_QUALIFICATIONS, DB_PREFIX_JOBS } from './constants';

const q = qualifications.reduce((acc, { name }) => {
  return {
    ...acc,
    ...{
      [name]: PropTypes.shape({ level: PropTypes.string }),
    },
  };
}, {});

export default PropTypes.shape({
  [DB_PREFIX_QUALIFICATIONS]: PropTypes.shape(q),
  [DB_PREFIX_JOBS]: PropTypes.arrayOf(
    PropTypes.shape({
      sector: PropTypes.string,
      role: PropTypes.string,
    })
  ),
});
